import Home from "./pages/Home";
import "remixicon/fonts/remixicon.css";
import { Toaster } from "react-hot-toast";
import FileUpload from "./components/FileUpload/FileUpload";
import { useContext } from "react";
import { Context } from "./context/Context";

function App() {
  const { isOpen } = useContext(Context);
  return (
    <>
      <Toaster
        position="top-center"
        containerClassName="mt-14 md:mt-16 "
        toastOptions={{
          className: `lgx:${
            isOpen && "ml-80"
          } border h-10 md:h-10 font-Blinker text-sm md:text-base`,
        }}
      />
      <FileUpload />
      <Home />
    </>
  );
}

export default App;
